import React from 'react'


export const SobreNosotrosUi = () => {
  return (
    <div>
      <div className='contenidoNosotros'>
        <figure className='imagen'>
          <img src="https://res.cloudinary.com/dlohqvzri/image/upload/v1684447278/Imagen1_aav3dx.jpg" alt="" className='img'/>
         </figure>
        <div className='nosotros'>
          <h1 className='tituloNosotros'>¿Quiénes Somos?</h1>
          <p>Somos una cadena hotelera 100% colombiana con 20 años de trayectoria en el sector turístico, nuestro objetivo es brindar vacaciones con propósito, ofreciendo a los colombianos la posibilidad de viajar y vivir experiencias para conocer los puntos turísticos más representativos en el país y Latinoamérica a precios cómodos, e impactando positivamente en la economía nacional, teniendo como principio una operación amigable con el medioambiente y el empoderamiento de las comunidades donde estamos presentes.</p>
        </div>
      </div>
      <div className='contenidoNosotros2'>
        <figure className='imagen'>
          <img src="https://res.cloudinary.com/dlohqvzri/image/upload/v1684447771/imagen3_spwtu2.jpg" alt="" className='img'/>
         </figure>
        <div className='nosotros2'>
          <h1 className='tituloNosotros'>Misión</h1>
          <p>Somos una cadena hotelera 100% colombiana con 20 años de trayectoria en el sector turístico, nuestro objetivo es brindar vacaciones con propósito, ofreciendo a los colombianos la posibilidad de viajar y vivir experiencias para conocer los puntos turísticos más representativos en el país y Latinoamérica a precios cómodos, e impactando positivamente en la economía nacional, teniendo como principio una operación amigable con el medioambiente y el empoderamiento de las comunidades donde estamos presentes.</p>
        </div>
      </div>
      <div className='contenidoNosotros3'>
        <figure className='imagen'>
          <img src="https://res.cloudinary.com/dlohqvzri/image/upload/v1685651882/excursion_dmcclq.jpg" alt="" className='img'/>
         </figure>
        <div className='nosotros'>
          <h1 className='tituloNosotros'>Visión</h1>
          <p>Somos una cadena hotelera 100% colombiana con 20 años de trayectoria en el sector turístico, nuestro objetivo es brindar vacaciones con propósito, ofreciendo a los colombianos la posibilidad de viajar y vivir experiencias para conocer los puntos turísticos más representativos en el país y Latinoamérica a precios cómodos, e impactando positivamente en la economía nacional, teniendo como principio una operación amigable con el medioambiente y el empoderamiento de las comunidades donde estamos presentes.</p>
        </div>
      </div>
      <div className='contenidoNosotros2'>
        <figure className='imagen'>
          <img src="https://res.cloudinary.com/dlohqvzri/image/upload/v1685651853/excursion1_4_dtr7vd.jpg" alt="" className='img'/>
         </figure>
        <div className='nosotros3'>
          <h1 className='tituloNosotros'>¿Qué ofrecemos?</h1>
          <p>-Piscilago</p>
          <p>-Santa Marta</p>
          <p>-Barranquilla</p>
          <p>-Cartagena</p>
          <p>-Coveñas</p>
          <p>-Volcan del Totumo</p>
        </div>
      </div>
      
    </div>
  )
}
